import { Box, Text } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1',
  fontSize: 'md',
  color: Styles.color.black,
  fontWeight: 'normal',
  lineHeight: '1.1',
});

export const Price = Text.withConfig({
  margin: '0',
  color: Styles.color.validated,
});

export const GreyStyledText = Text.withConfig({
  margin: '0',
  color: Styles.color.grey.six,
});

export const Divider = Text.withConfig({
  mx: { base: '1', sm: '2' },
  my: '0',
  color: Styles.color.grey.two,
});
